import React, { useEffect, useState } from 'react'

import * as S from './TextTab.style'
import TextForm from '../TextForm'
import { TrainingStatus } from '../../../../settings/constants/trainingStatus'
import { alertError, alertSuccess } from 'api'
import SourcesTable from '../SourcesTable'
import { SourceTypeMap } from 'tabs/nlp/constants'
import { knowledgeService } from 'tabs/nlp/api/knowledgeWebsite'

export const onTrainSuccessAlertMessage =
  'Training has successfully started. Once training is completed, we will send you an email notification'

export const TextTab = ({ activeBot, sourceId }) => {
  const [sources, setSources] = useState([])
  const [trainingStatus, setTrainingStatus] = useState(TrainingStatus.PENDING)

  useEffect(() => {
    knowledgeService.getKnowledgeSources(SourceTypeMap.TEXT).then(res => {
      const trainingStatus = res?.sources?.some(source => source.status === TrainingStatus.PENDING)
        ? TrainingStatus.PENDING
        : TrainingStatus.READY
      setSources(res?.sources || [])
      setTrainingStatus(trainingStatus)
    })
  }, [])

  const handleAdd = async (text: string, title: string): Promise<void> => {
    const body = { text, title, type: SourceTypeMap.TEXT }

    const res = await knowledgeService.createTextKnowledgeSources(body)
    setSources([...sources, res])
    alertSuccess('Text is added successfully')
  }

  const handleDelete = source => {
    const sourceId = source._id
    return knowledgeService
      .deleteKnowledgeSource(SourceTypeMap.TEXT, sourceId)
      .then(() => {
        const sourcesCopy = sources.filter(x => x._id !== sourceId)
        setSources(sourcesCopy)
      })
      .then(() => alertSuccess('Text is deleted successfully'))
  }

  const handleTrain = () => {
    const body = sources.filter(x => ['NOT_TRAINED', 'FAILED'].includes(x.status)).map(x => x._id)
    knowledgeService
      .train(SourceTypeMap.TEXT, body)
      .then(() => {
        setTrainingStatus(TrainingStatus.PENDING)
        alertSuccess(onTrainSuccessAlertMessage)
      })
      .catch(error => alertError(error?.message || 'Something went wrong'))
  }

  return (
    <S.TextTab>
      <TextForm onClick={handleAdd} trainingStatus={trainingStatus} />
      <SourcesTable
        sources={sources}
        setSources={setSources}
        onDelete={handleDelete}
        onTrain={handleTrain}
        trainingStatus={trainingStatus}
        sourceId={sourceId}
      />
    </S.TextTab>
  )
}
